var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimcard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 68,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.238 36.912c0-.92.746-1.667 1.667-1.667H14.86c.92 0 1.667.747 1.667 1.667v28.535c0 .92-.747 1.666-1.667 1.666H1.905c-.92 0-1.667-.746-1.667-1.666V36.912zm3.334 1.667v25.2h9.621v-25.2H3.572z",
    fill: "url(#simcard_svg__paint0_linear_705_30056)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.353 43.416h-.008l-.009.002-.016.001-.02.001a1.65 1.65 0 01-.124.005H14.86a1.667 1.667 0 110-3.333h10.26a4.922 4.922 0 01.77.033c.469.056 1.093.19 1.84.481 1.499.584 3.443 1.78 5.627 4.165l4.459 4.78h7.112a1.667 1.667 0 010 3.334h-7.837c-.462 0-.903-.192-1.218-.53l-4.97-5.328c-1.89-2.066-3.424-2.941-4.383-3.315a4.312 4.312 0 00-1.03-.278 1.643 1.643 0 00-.185-.014",
    fill: "url(#simcard_svg__paint1_linear_705_30056)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.45 53.057a1.667 1.667 0 012.303-.507l5.587 3.568h11.509a1.667 1.667 0 010 3.334H32.853c-.318 0-.63-.091-.897-.262l-5.998-3.831a1.667 1.667 0 01-.507-2.302z",
    fill: "url(#simcard_svg__paint2_linear_705_30056)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.181 55.57c.576.718.46 1.767-.257 2.343l-7.136 5.722c-2.795 2.177-5.418 3.063-7.39 3.388-.982.162-1.795.183-2.379.161a8.374 8.374 0 01-.825-.07h-19.3c-1.951 0-3.638-.276-4.84-.55a18.87 18.87 0 01-1.427-.385 12.666 12.666 0 01-.515-.173l-.035-.013-.011-.004-.005-.002s-.003-.001.596-1.557l-.599 1.556a1.66 1.66 0 01-.268-.133l-6.798-4.143a1.667 1.667 0 011.735-2.846l6.652 4.055c.061.02.144.048.246.08.266.084.666.199 1.174.315 1.018.233 2.45.466 4.096.466h19.432a1.675 1.675 0 01.323.031h-.006l.082.01c.085.01.226.025.42.032.385.015.972.002 1.71-.12 1.463-.24 3.555-.917 5.874-2.721l7.109-5.7a1.667 1.667 0 012.342.258zm-17.537 8.24a.06.06 0 00-.008-.001l.008.001z",
    fill: "url(#simcard_svg__paint3_linear_705_30056)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.543 50.02c.576.718.46 1.767-.257 2.343l-7.118 5.707a1.667 1.667 0 01-1.042.366h-2.924a1.667 1.667 0 010-3.333h2.338l6.66-5.34a1.667 1.667 0 012.343.257z",
    fill: "url(#simcard_svg__paint4_linear_705_30056)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.07 52.665c-.708-.866-1.977-.968-2.768-.316a1.667 1.667 0 11-2.119-2.574c2.242-1.846 5.6-1.484 7.454.762 1.901 2.226 1.507 5.548-.697 7.362a1.667 1.667 0 01-2.118-2.573c.83-.684.918-1.884.276-2.63l-.027-.031z",
    fill: "url(#simcard_svg__paint5_linear_705_30056)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.182 51.14c0-.92.746-1.667 1.666-1.667 2.724 0 5.026 2.197 5.026 4.95 0 2.755-2.302 4.95-5.026 4.95a1.667 1.667 0 110-3.333c.955 0 1.692-.774 1.692-1.617 0-.842-.737-1.616-1.692-1.616-.92 0-1.666-.746-1.666-1.667z",
    fill: "url(#simcard_svg__paint6_linear_705_30056)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.765 1.432a2.613 2.613 0 011.848-.766h17.476c.693 0 1.358.276 1.847.766m0 0l7.287 7.287c.49.49.766 1.154.766 1.847v27.381a2.613 2.613 0 01-2.613 2.613H34.613A2.613 2.613 0 0132 37.947V21.44c0-.532.43-.962.962-.962h.689v-3.03h-.689a.962.962 0 01-.962-.961V3.279c0-.693.275-1.357.765-1.847m1.159 14.092h.689c.531 0 .962.43.962.962v4.953c0 .53-.43.962-.962.962h-.689v15.546a.69.69 0 00.689.69h24.763a.689.689 0 00.689-.69v-27.38a.69.69 0 00-.202-.488l-7.287-7.287a.69.69 0 00-.487-.202H34.613a.689.689 0 00-.689.69v12.244z",
    fill: "url(#simcard_svg__paint7_linear_705_30056)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.565 5.619c.531 0 .962.43.962.962v8.254a.962.962 0 01-1.924 0V6.581c0-.532.43-.962.962-.962z",
    fill: "url(#simcard_svg__paint8_linear_705_30056)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.518 5.619c.531 0 .962.43.962.962v8.254a.962.962 0 11-1.924 0V6.581c0-.532.43-.962.962-.962z",
    fill: "url(#simcard_svg__paint9_linear_705_30056)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.47 5.619c.532 0 .963.43.963.962v8.254a.962.962 0 01-1.924 0V6.581c0-.532.43-.962.962-.962z",
    fill: "url(#simcard_svg__paint10_linear_705_30056)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.423 8.92c.532 0 .963.432.963.963v6.606a.962.962 0 01-1.925 0V9.883c0-.531.43-.962.962-.962z",
    fill: "url(#simcard_svg__paint11_linear_705_30056)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.365 1.03A3.18 3.18 0 0134.613.1h17.476a3.18 3.18 0 012.248.931m-21.32.967c-.29.362-.45.813-.45 1.281v13.207c0 .218.177.395.395.395h.689c.313 0 .567.254.567.567v3.029a.567.567 0 01-.567.566h-.689a.395.395 0 00-.395.396v16.508a2.046 2.046 0 002.046 2.046h24.763a2.046 2.046 0 002.046-2.046V10.566c0-.543-.216-1.063-.6-1.447L53.703 2H33.017zm21.32-.967l7.287 7.287a3.18 3.18 0 01.931 2.248v27.381a3.18 3.18 0 01-3.179 3.18H34.613a3.18 3.18 0 01-3.18-3.18V21.44c0-.845.685-1.529 1.53-1.529h.121v-1.895h-.122a1.529 1.529 0 01-1.529-1.529V3.279c0-.843.335-1.652.932-2.248m2.248 2.126a.122.122 0 00-.122.122v11.678h.122c.844 0 1.529.685 1.529 1.529v4.953c0 .844-.685 1.528-1.529 1.528h-.122v14.98a.123.123 0 00.122.123h24.763a.122.122 0 00.122-.123v-27.38a.123.123 0 00-.036-.087l-7.287-7.287a.123.123 0 00-.086-.036H34.613zm17.476-1.134H34.613a1.256 1.256 0 00-1.256 1.256v12.245c0 .313.254.567.567.567h.689c.218 0 .395.177.395.395v4.953a.395.395 0 01-.395.395h-.689a.567.567 0 00-.567.567v15.546a1.255 1.255 0 001.256 1.256h24.763a1.255 1.255 0 001.256-1.256v-27.38c0-.334-.133-.653-.368-.889l-7.287-7.287a1.257 1.257 0 00-.888-.368zM38.037 6.581a1.529 1.529 0 113.057 0v8.254a1.528 1.528 0 11-3.057 0V6.581zm1.528-.396a.395.395 0 00-.395.396v8.254a.395.395 0 00.79 0V6.581a.395.395 0 00-.395-.396zm3.425.396a1.529 1.529 0 013.057 0v8.254a1.529 1.529 0 01-3.057 0V6.581zm1.528-.396a.395.395 0 00-.395.396v8.254a.395.395 0 00.79 0V6.581a.395.395 0 00-.395-.396zm3.424.396a1.529 1.529 0 013.057 0v8.254a1.529 1.529 0 01-3.057 0V6.581zm1.529-.396a.395.395 0 00-.395.396v8.254a.395.395 0 00.79 0V6.581a.395.395 0 00-.395-.396zm3.423 3.698a1.529 1.529 0 113.058 0v6.606a1.529 1.529 0 01-3.058 0V9.883zm1.53-.396a.396.396 0 00-.396.396v6.606a.396.396 0 10.79 0V9.883a.396.396 0 00-.395-.396z",
    fill: "url(#simcard_svg__paint12_linear_705_30056)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "simcard_svg__paint0_linear_705_30056",
    x1: 33.547,
    y1: 0.1,
    x2: 33.547,
    y2: 67.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451287"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "simcard_svg__paint1_linear_705_30056",
    x1: 33.547,
    y1: 0.1,
    x2: 33.547,
    y2: 67.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451287"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "simcard_svg__paint2_linear_705_30056",
    x1: 33.547,
    y1: 0.1,
    x2: 33.547,
    y2: 67.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451287"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "simcard_svg__paint3_linear_705_30056",
    x1: 33.547,
    y1: 0.1,
    x2: 33.547,
    y2: 67.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451287"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "simcard_svg__paint4_linear_705_30056",
    x1: 33.547,
    y1: 0.1,
    x2: 33.547,
    y2: 67.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451287"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "simcard_svg__paint5_linear_705_30056",
    x1: 33.547,
    y1: 0.1,
    x2: 33.547,
    y2: 67.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451287"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "simcard_svg__paint6_linear_705_30056",
    x1: 33.547,
    y1: 0.1,
    x2: 33.547,
    y2: 67.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451287"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "simcard_svg__paint7_linear_705_30056",
    x1: 33.547,
    y1: 0.1,
    x2: 33.547,
    y2: 67.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451287"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "simcard_svg__paint8_linear_705_30056",
    x1: 33.547,
    y1: 0.1,
    x2: 33.547,
    y2: 67.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451287"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "simcard_svg__paint9_linear_705_30056",
    x1: 33.547,
    y1: 0.1,
    x2: 33.547,
    y2: 67.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451287"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "simcard_svg__paint10_linear_705_30056",
    x1: 33.547,
    y1: 0.1,
    x2: 33.547,
    y2: 67.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451287"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "simcard_svg__paint11_linear_705_30056",
    x1: 33.547,
    y1: 0.1,
    x2: 33.547,
    y2: 67.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451287"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "simcard_svg__paint12_linear_705_30056",
    x1: 33.547,
    y1: 0.1,
    x2: 33.547,
    y2: 67.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#451287"
  })))));
}
export default __webpack_public_path__ + "static/simcard.420712ff.svg";
export { SvgSimcard as ReactComponent };